export default {
    url: '/detail/:id',
    template: '<courses-application-detail application="vm.application" fields="vm.fields"/>',
    resolve: {
        application ($stateParams, CourseApplicationResource) {
            return CourseApplicationResource.get({ id: $stateParams.id,
                expand: 'course.activeI18n,employee,course.fields,occurrence.courseOccurrenceParticipants'
            }).$promise;
        },
        classifiers (ClassifierResource) {
            return ClassifierResource.query({ pageSize: 0, expand: 'activeI18n' }).$promise;
        }
    },
    controller (lodash, application, classifiers, CLASSIFIER_ENUM) {
        this.application = application;
        this.fields = classifiers.filter((classifier) => classifier.type === CLASSIFIER_ENUM.KEYS.FIELD);
    }
};



// WEBPACK FOOTER //
// ./src/app/states/authorized/courses/application/detail/index.js